import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Breadcrumb({
  items,
}: {
  items: { label: string; to?: string }[];
}) {
  return (
    <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
          {it.to ? (
            <Link
              to={it.to}
              className="whitespace-nowrap text-foreground-600 transition-colors hover:text-primary-700"
            >
              {it.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap font-medium text-foreground-950">
              {it.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-black text-background-50">
                辨
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                辨真社
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              专注免费爆料真实性核查与辟谣可信度分析，用证据链帮你辨别瓜料真伪，吃瓜不被带节奏。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              快捷导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li><Link to="/" className="transition-colors hover:text-primary-700">首页</Link></li>
              <li><Link to="/topics" className="transition-colors hover:text-primary-700">事件解析</Link></li>
              <li><Link to="/guide" className="transition-colors hover:text-primary-700">鉴别指南</Link></li>
              <li><Link to="/faq" className="transition-colors hover:text-primary-700">常见问题</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-primary-700">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              核查分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/topics?c=${c.key}`}
                    className="transition-colors hover:text-primary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              联系我们
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" />
                feedback@bianzhenshe.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-message-3-line text-primary-600" />
                你看到疑似爆料的瓜，欢迎投稿求证
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:text-primary-700">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:text-primary-700">
                <i className="ri-bilibili-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:text-primary-700">
                <i className="ri-wechat-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 py-5 text-xs leading-relaxed text-foreground-600">
          <p className="mb-2">
            免责声明：本站内容为网络信息的整理与科普，仅作参考，不构成任何定论。相关争议请以官方机构与权威渠道发布为准。
          </p>
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 辨真社 BianZhenShe · 保留所有权利</span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-focus-3-line text-primary-600" />
              吃瓜有据 · 求证有道
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}